import { memo, useCallback, Dispatch, SetStateAction, FC, ChangeEvent } from 'react'
import { Select } from '@chakra-ui/react'

import { Pagination } from 'types'

type Value = {
  by: string
  order: string
}

type SortOption = {
  label: string
  value: Value | Value[]
}

type Props = {
  sortOptions: SortOption[]
  setPagination: Dispatch<SetStateAction<Pagination>>
}

const SortingSelect: FC<Props> = ({ sortOptions, setPagination }) => {
  const handleOnChange = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target
    setPagination((oldPagination) => {
      return { ...oldPagination, sort: JSON.parse(value) }
    })
  }, [])

  return (
    <Select name="order" minWidth="max-content" onChange={handleOnChange}>
      {sortOptions.map(({ value, label }) => (
        <option key={label} value={JSON.stringify(value)}>
          {label}
        </option>
      ))}
    </Select>
  )
}

export default memo(SortingSelect)
